import { useState, useEffect } from "react";

import {
  orgranizationDepartment,
  orgranizationRole,
} from "../core/dictionary/orginazation-dropdown";
import axiosService from "../core/services/axios-service";
import { ApiRoutes } from "../core/dictionary/api-url";
import {
  individualOrganisationActionType,
} from "../core/dictionary/global-enums";
import ToastService from "../core/services/toaster-service";
import Loader from "./designs/loader";

export default function AddEditCoachTeamMember({
  type, // "coach" or "team-member"
  id, // for edit, pass the coach/team-member id
  organizationId, // required for adding a new coach/team-member
  onSuccess,
  uniqueNumber,
  isSignup, // when true: "Submit" button label + full-width button
}) {
  const isEdit = Boolean(id);
  const [form, setForm] = useState({
    fullName: "",
    title: "",
    email: "",
    phoneNumber: "",
    licenseNumber: "",
    healthSystem: "",
    department: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  useEffect(() => {
    setForm({
      fullName: "",
      title: "",
      email: "",
      phoneNumber: "",
      licenseNumber: "",
      healthSystem: "",
      department: "",
    });
  }, [type, uniqueNumber]);

  // Fetch details if editing
  useEffect(() => {
    if (isEdit && id) {
      setLoading(true);
      axiosService
        .get(`${ApiRoutes.VIEW_COACH_TEAM_MEMBER}/${id}`)
        .then((res) => {
          if (res.data && res.data.data) {
            setForm({
              fullName: res.data.data.fullName || "",
              title: res.data.data.title || "",
              email: res.data.data.email || "",
              phoneNumber: res.data.data.phoneNumber || "",
              licenseNumber: res.data.data.licenseNumber || "",
              healthSystem: res.data.data.healthSystem || "",
              department: res.data.data.department || "",
            });
          } else {
            setError("Failed to fetch details.");
          }
        })
        .catch(() => setError("Server error. Please try again."))
        .finally(() => setLoading(false));
    } else {
      setForm({
        fullName: "",
        title: "",
        email: "",
        phoneNumber: "",
        licenseNumber: "",
        healthSystem: "",
        department: "",
      });
    }
  }, [isEdit, id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    let payload = { ...form };
    payload.organization_id = organizationId;
    if (
      type === individualOrganisationActionType.addCoach ||
      type === individualOrganisationActionType.addTeamMember
    ) {
      submitAdd(payload);
    } else {
      submitEdit(payload);
    }
  };
  const submitAdd = async (payload) => {
    try {
      const apiUrl =
        type === individualOrganisationActionType.addCoach
          ? ApiRoutes.ADD_COACH
          : type === individualOrganisationActionType.addTeamMember
          ? ApiRoutes.ADD_TEAM_MEMBER
          : "";
      if ("" === apiUrl) {
        setError("Invalid action type");
        setLoading(false);
        return;
      }
      const res = await axiosService.post(apiUrl, payload);
      if (res.data && res.data.success) {
        ToastService.success(res.data.message);
        if (onSuccess) onSuccess(res.data);
      } else {
        setError(res.data.message || "Failed to save data");
        ToastService.error(res.data.message || "Failed to save data");
      }
    } catch (err) {
      setError("Server error. Please try again.");
      ToastService.error("Server error. Please try again.");
    }
    setLoading(false);
  };
  const submitEdit = async (payload) => {
    try {
      const apiUrl =
        type === individualOrganisationActionType.editCoach
          ? ApiRoutes.EDIT_COACH + `/${id}`
          : type === individualOrganisationActionType.editTeam
          ? ApiRoutes.EDIT_TEAM_MEMBER + `/${id}`
          : "";
      if ("" === apiUrl) {
        setError("Invalid action type");
        setLoading(false);
        return;
      }
      const res = await axiosService.put(apiUrl, payload);
      if (res.data && res.data.success) {
        ToastService.success(res.data.message);
        if (onSuccess) onSuccess(res.data);
      } else {
        setError(res.data.message || "Failed to save data");
        ToastService.error(res.data.message || "Failed to save data");
      }
    } catch (err) {
      setError("Server error. Please try again.");
      ToastService.error("Server error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <>
      {!(loading && isEdit) ? (
        <form onSubmit={handleSubmit} className="p-3">
          <div className="mb-3">
            <label className="form-label">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter full name"
              className="form-control"
              value={form.fullName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Title</label>
            <select
              name="title"
              placeholder="Select Title"
              className="form-select"
              value={form.title}
              onChange={handleChange}
              required
            >
              <option value="">Select Title</option>
              {orgranizationRole.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email"
                className="form-control"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                name="phoneNumber"
                placeholder="Enter phone number"
                className="form-control"
                value={form.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">License Number</label>
              <input
                type="text"
                name="licenseNumber"
                placeholder="Enter license number"
                className="form-control"
                value={form.licenseNumber}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Health System</label>
              <input
                type="text"
                name="healthSystem"
                placeholder="Enter health system"
                className="form-control"
                value={form.healthSystem}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-12">
              <label className="form-label">Department</label>
              <select
                name="department"
                placeholder="Select Department"
                className="form-select"
                value={form.department}
                onChange={handleChange}
                required
              >
                <option value="">Select Department</option>
                {orgranizationDepartment.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {error && <div className="text-danger mb-2">{error}</div>}
          {success && <div className="text-success mb-2">{success}</div>}
          <button
            type="submit"
            className={`btn btn-gradient${isSignup ? " w-100" : ""}`}
            disabled={loading}
          >
            {loading
              ? isSignup
                ? "Submitting..."
                : isEdit
                ? "Updating..."
                : "Saving..."
              : isSignup
              ? "Submit"
              : isEdit
              ? "Update"
              : "Add"}
          </button>
        </form>
      ) : (
        <Loader
          text={
            "Loading " +
            (type === individualOrganisationActionType.editCoach
              ? "coach"
              : "team member") +
            " details..."
          }
        />
      )}
    </>
  );
}
